@use '../../scss/utility/functions' as utility;
@use './radio-button-vars';

:host {
  @include radio-button-vars.wb-radio-button-vars;

  display: block;
  position: relative;
}

:host(:hover:not([disabled])) {
  @include radio-button-vars.wb-radio-button-hover-vars;
}

:host(:focus-within) {
  @include radio-button-vars.wb-radio-button-focus-vars;
}

input:active ~ .indicator {
  @include radio-button-vars.wb-radio-button-active-vars;
}

input:checked ~ .indicator {
  @include radio-button-vars.wb-radio-button-checked-vars;
}

:host(:not([disabled]):hover) input:checked ~ .indicator {
  @include radio-button-vars.wb-radio-button-checked-hover-vars;
}

:host(:focus-within) input:checked ~ .indicator {
  @include radio-button-vars.wb-radio-button-checked-focus-vars;
}

input:checked:active ~ .indicator {
  @include radio-button-vars.wb-radio-button-checked-active-vars;
}

:host([error]) {
  @include radio-button-vars.wb-radio-button-error-vars;
}

:host([error]:hover:not([disabled])) {
  @include radio-button-vars.wb-radio-button-error-hover-vars;
}

:host([error]:focus-within) {
  @include radio-button-vars.wb-radio-button-error-focus-vars;
}

:host([error]) input:active ~ .indicator {
  @include radio-button-vars.wb-radio-button-error-active-vars;
}

:host([error]) input:checked ~ .indicator {
  @include radio-button-vars.wb-radio-button-checked-error-vars;
}

:host([error]:hover:not([disabled])) input:checked ~ .indicator {
  @include radio-button-vars.wb-radio-button-checked-error-hover-vars;
}

:host([error]:focus-within) input:checked ~ .indicator {
  @include radio-button-vars.wb-radio-button-checked-error-focus-vars;
}

:host([error]) input:checked:active ~ .indicator {
  @include radio-button-vars.wb-radio-button-checked-error-active-vars;
}

:host([disabled]) {
  label,
  input ~ .radio {
    cursor: not-allowed;
    pointer-events: none;
    opacity: var(--radio-button-opacity-disabled);
  }
}

label {
  display: inline-block;
  cursor: pointer;
  color: var(--radio-button-text-color);
  padding-inline-start: calc(var(--radio-button-size) + var(--radio-button-gap));
}

input {
  width: var(--radio-button-size);
  height: var(--radio-button-size);
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  margin: 0;
  opacity: 0;
  padding: 0;
  z-index: -1;

  &:checked ~ .indicator {
    &::after {
      display: block;
      position: absolute;
      content: '';
      width: var(--radio-button-dot-size);
      height: var(--radio-button-dot-size);
      background-color: var(--radio-button-dot-color);
      border-radius: var(--wb-radius-full);
    }
  }

  &:not(:disabled):focus ~ .indicator,
  &:not(:disabled):active ~ .indicator {
    outline: var(--radio-button-border-weight) solid var(--radio-button-border-ring-color);
    outline-offset: utility.wb-pixel-to-rem(1px);
  }
}

.indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--radio-button-size);
  height: var(--radio-button-size);
  background-color: var(--radio-button-background-color);
  position: absolute;
  inset-block: 0;
  inset-inline: 0;
  border-radius: var(--radio-button-border-radius);
  border: var(--radio-button-border-weight) solid var(--radio-button-border-color);
  box-sizing: border-box;
}

::slotted(.wb-control-error),
::slotted(.wb-control-hint) {
  padding-inline-start: calc(var(--radio-button-size) + var(--radio-button-gap));
  margin-block-start: var(--radio-button-text-gap);
}

::slotted(.wb-control-hint) {
  color: var(--radio-button-hint-text-color);
}

input,
label {
  -webkit-tap-highlight-color: transparent;
}
